import {
  Typography,
  Box,
  Divider,
  Grid,
} from "@mui/material";

const BendecidosConVillaInfo = () => {
  return (
    <Grid item xs={12} xl={12} lg={12} sm={12} p={4}>
      <Box
        sx={{
          p: 4,
          borderRadius: 4,
          boxShadow: 3,
          maxWidth: 600,
          margin: "0 auto",
        }}
      >
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Puedes comprar a partir de <strong>2 tickets</strong> en adelante
        </Typography>

        <Divider sx={{ my: 2, borderColor: "#555" }} />

        <Typography variant="body1" gutterBottom>
          🎯 <strong>PREMIOS MOTO OTLOOK 0KM</strong><br />
          Si participas con:
          <br />
          • <strong>10 tickets</strong>: MOTO 0KM + 300$<br />
          • <strong>20 tickets</strong>: MOTO 0KM + 400$
        </Typography>

        <Divider sx={{ my: 2, borderColor: "#555" }} />

        <Typography variant="body1" gutterBottom>
          🎁 <strong>La persona que más tickets compre</strong> en todo el sorteo será premiada con <strong>400$</strong>
        </Typography>

        <Divider sx={{ my: 2, borderColor: "#555" }} />

        <Typography variant="body1" gutterBottom>
          🎟️ <strong>TICKETS CON PREMIOS INSTANTÁNEOS: 50$</strong>
        </Typography>

        <Typography variant="body2" sx={{ mt: 1, fontStyle: "italic" }}>
          Si te sale alguno de estos tickets, ganas 50$ instantáneamente:
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, wordBreak: "break-word" }}>
          2121 - 3333 - 7878 - 8787 - 7777
        </Typography>

        <Typography variant="body2" sx={{ mt: 2 }}>
          🙏🏻 Bendiciones y mucha suerte
        </Typography>
      </Box>
    </Grid>
  );
};

export default BendecidosConVillaInfo;
